var _style, _rect, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13, _defs14, _defs15, _defs16, _defs17, _defs18, _defs19, _defs20, _defs21, _defs22, _defs23, _defs24, _rect2, _defs25, _defs26, _rect3, _defs27, _defs28, _defs29, _defs30, _defs31, _defs32, _defs33, _defs34, _defs35, _defs36, _defs37, _defs38, _defs39, _defs40, _defs41, _defs42, _defs43, _defs44, _defs45, _defs46, _defs47, _defs48, _defs49, _defs50, _defs51, _defs52, _defs53, _defs54, _defs55, _defs56, _defs57, _defs58, _defs59, _defs60, _defs61, _defs62, _defs63, _defs64, _defs65, _defs66, _defs67, _defs68, _defs69, _defs70, _defs71, _defs72, _defs73, _defs74, _defs75, _defs76, _defs77, _defs78, _defs79, _defs80, _defs81, _defs82, _defs83;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKpi1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 175.2 163.5",
    style: {
      enableBackground: "new 0 0 175.2 163.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{clip-path:url(#SVGID_00000124155031878409148940000006425088544194770851_);}\n\t.st2{clip-path:url(#SVGID_00000033348298358033405550000003285295288570016692_);}\n\t.st3{clip-path:url(#SVGID_00000090252387037344625260000002478630258927100599_);fill:#808080;}\n\t.st4{clip-path:url(#SVGID_00000098938746671653268110000005354327616822981802_);}\n\t.st5{clip-path:url(#SVGID_00000101789695865107257460000013287550238930868097_);}\n\t.st6{clip-path:url(#SVGID_00000027588923904112829600000016457266431970191494_);fill:#808080;}\n\t.st7{clip-path:url(#SVGID_00000121252374846253541720000013436996291370926267_);}\n\t.st8{clip-path:url(#SVGID_00000032628953226298301300000000619321629949302690_);}\n\t.st9{clip-path:url(#SVGID_00000181801446312874478970000010992321990362873019_);fill:#808080;}\n\t.st10{clip-path:url(#SVGID_00000168829806477661653080000003594006608446703238_);}\n\t.st11{clip-path:url(#SVGID_00000161620732211760101710000015117283209892122758_);}\n\t.st12{clip-path:url(#SVGID_00000049913379756979222840000003130556447060645297_);fill:#808080;}\n\t.st13{clip-path:url(#SVGID_00000046299172185400976610000015086604209013555893_);}\n\t.st14{clip-path:url(#SVGID_00000040537736105400581830000011943305498254410936_);}\n\t.st15{clip-path:url(#SVGID_00000036228083997119264680000008283263932943628691_);fill:#808080;}\n\t.st16{clip-path:url(#SVGID_00000161597427959388945360000003691147140864993168_);}\n\t.st17{clip-path:url(#SVGID_00000067193874789114180530000014295921360444160913_);}\n\t.st18{clip-path:url(#SVGID_00000115515135387544345560000015378336317222397605_);fill:#808080;}\n\t.st19{clip-path:url(#SVGID_00000046336520589202242090000018005741698361149628_);}\n\t.st20{clip-path:url(#SVGID_00000075856336367156310480000017446524733530399658_);}\n\t.st21{clip-path:url(#SVGID_00000074415540046150975900000016897142527839809665_);fill:#808080;}\n\t.st22{clip-path:url(#SVGID_00000067218691650466599770000003589494304713372304_);}\n\t.st23{clip-path:url(#SVGID_00000005242954231799655090000005703920247129583751_);}\n\t.st24{clip-path:url(#SVGID_00000124147006535027179530000015355973170865322936_);fill:#808080;}\n\t.st25{clip-path:url(#SVGID_00000134221529229718975260000009829762835677271713_);}\n\t.st26{clip-path:url(#SVGID_00000129195718256798667460000016616302894660480401_);fill:#808080;}\n\t.st27{clip-path:url(#SVGID_00000078038768899696400440000003895384633823234971_);}\n\t.st28{clip-path:url(#SVGID_00000150082356481261158330000001701653033999359623_);}\n\t.st29{clip-path:url(#SVGID_00000059305358139423174940000006886392489675718827_);}\n\t.st30{clip-path:url(#SVGID_00000040566902014456983600000014486736808070203061_);fill:#808080;}\n\t.st31{clip-path:url(#SVGID_00000172408986566760844080000009853296798959443599_);}\n\t.st32{clip-path:url(#SVGID_00000118356949755101851150000005722560062329659579_);}\n\t.st33{clip-path:url(#SVGID_00000011740580867216032620000002795919446252369306_);fill:#808080;}\n\t.st34{clip-path:url(#SVGID_00000002362027088989747160000014919599929544955320_);}\n\t.st35{clip-path:url(#SVGID_00000046323897280631578130000012591055715008621448_);}\n\t.st36{clip-path:url(#SVGID_00000042011715048105086790000000397895614959398528_);fill:#808080;}\n\t.st37{clip-path:url(#SVGID_00000057838754073314844090000015824356628382478765_);}\n\t.st38{clip-path:url(#SVGID_00000002349859221033243200000014366788217922695831_);}\n\t.st39{clip-path:url(#SVGID_00000176009043156924433120000009916842778453150654_);fill:#808080;}\n\t.st40{clip-path:url(#SVGID_00000031886263497511297550000003978586957446493575_);}\n\t.st41{clip-path:url(#SVGID_00000131325343650235760710000016478269932547526317_);}\n\t.st42{clip-path:url(#SVGID_00000016763378668553813140000009772593381008609715_);fill:#808080;}\n\t.st43{clip-path:url(#SVGID_00000085941624675827526500000009695550081013851836_);}\n\t.st44{clip-path:url(#SVGID_00000067949252768085330160000005546864662216367002_);}\n\t.st45{clip-path:url(#SVGID_00000151535840196680285000000000752411796554242232_);fill:#808080;}\n\t.st46{clip-path:url(#SVGID_00000003809992599133453370000013717555545765649296_);}\n\t.st47{clip-path:url(#SVGID_00000009572478683740519800000004093037001840469424_);}\n\t.st48{clip-path:url(#SVGID_00000011751262461728706090000014313790923199222671_);fill:#808080;}\n\t.st49{clip-path:url(#SVGID_00000145050979044227803800000007619065456550183097_);}\n\t.st50{clip-path:url(#SVGID_00000060730301799869089220000008286318025098937745_);}\n\t.st51{clip-path:url(#SVGID_00000000921072459819314830000005893831475245201084_);fill:#808080;}\n\t.st52{clip-path:url(#SVGID_00000018204732610761385130000011393901184689148558_);}\n\t.st53{clip-path:url(#SVGID_00000006678312440865584340000010565380400277732229_);}\n\t.st54{clip-path:url(#SVGID_00000125588648021079998140000018162893761859989682_);fill:#808080;}\n\t.st55{clip-path:url(#SVGID_00000083087069457173076440000009628448352544192939_);}\n\t.st56{clip-path:url(#SVGID_00000150821537460786242520000001815635689459015359_);}\n\t.st57{clip-path:url(#SVGID_00000086679844977803122360000010072307329434759861_);fill:#808080;}\n\t.st58{clip-path:url(#SVGID_00000095324713998293098270000007976401626431193243_);}\n\t.st59{clip-path:url(#SVGID_00000164500474308982692660000006350528800115826606_);}\n\t.st60{clip-path:url(#SVGID_00000002342256008071480130000016776727193102111380_);fill:#808080;}\n\t.st61{clip-path:url(#SVGID_00000067201283450033418190000001681345210727631547_);}\n\t.st62{clip-path:url(#SVGID_00000171681486652327445730000001738933695367838093_);}\n\t.st63{clip-path:url(#SVGID_00000069394506520395547210000007701747190476257679_);fill:#808080;}\n\t.st64{clip-path:url(#SVGID_00000142165954180741976450000016609261194320051127_);}\n\t.st65{clip-path:url(#SVGID_00000082330309897595221420000005777143909687476380_);}\n\t.st66{clip-path:url(#SVGID_00000144312218520362038750000015891961625452509842_);fill:#808080;}\n\t.st67{clip-path:url(#SVGID_00000072963968788944552960000008708498150705730738_);}\n\t.st68{clip-path:url(#SVGID_00000080188903484974678860000001701732506645770687_);}\n\t.st69{clip-path:url(#SVGID_00000130623953139308738620000003687639604052325810_);fill:#808080;}\n\t.st70{clip-path:url(#SVGID_00000156550196135362943340000014059163017170331318_);}\n\t.st71{clip-path:url(#SVGID_00000057866526020658263960000010215621357210035616_);}\n\t.st72{clip-path:url(#SVGID_00000044162898934150230250000015684703429990559382_);fill:#808080;}\n\t.st73{clip-path:url(#SVGID_00000033364161619430539920000012578523253916585099_);}\n\t.st74{clip-path:url(#SVGID_00000005963249750118136120000007606012971731915406_);}\n\t.st75{clip-path:url(#SVGID_00000078046828785542388880000000285991575433641392_);fill:#808080;}\n\t.st76{clip-path:url(#SVGID_00000169534777927863094120000006086851291011608970_);}\n\t.st77{clip-path:url(#SVGID_00000006710332756766215370000006844002682235965630_);}\n\t.st78{clip-path:url(#SVGID_00000159440180582198115610000000594644240409409171_);fill:#808080;}\n\t.st79{clip-path:url(#SVGID_00000096031808717117426420000006338815012890797209_);}\n\t.st80{clip-path:url(#SVGID_00000026857708360954224630000005632364082290069904_);}\n\t.st81{clip-path:url(#SVGID_00000163767557716342796830000013218457919991418519_);fill:#808080;}\n")), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 174,
    height: 129,
    xlinkHref: "AF267CD7290434E1.png",
    transform: "matrix(0.9935 0 0 0.9935 1.6615 24.0568)"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.6,
    y: 24.1,
    className: "st0",
    width: 173,
    height: 128
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000097488987682729250040000013822313740208405413_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000097488987682729250040000013822313740208405413_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000035511688276360828010000000435983069432536741_",
    d: "M30.2,76c-0.4-2.5-2.5-4.5-5.2-4.5 c-2.9,0-5.2,2.3-5.2,5.2c0,2.9,2.3,5.2,5.2,5.2c2.6,0,4.8-1.9,5.2-4.5h8.9c0.1-0.5,0.2-1,0.4-1.5h-9.3V76z M25,80.5 c-2,0-3.7-1.7-3.7-3.7s1.7-3.7,3.7-3.7s3.7,1.7,3.7,3.7S27.1,80.5,25,80.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080897987514901277760000007838786789450320311_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000035511688276360828010000000435983069432536741_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000080897987514901277760000007838786789450320311_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000170994183850517368170000012512250771675336631_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000103979540576748656050000004377520222082546053_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000170994183850517368170000012512250771675336631_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 18.8,
    y: 70.5,
    style: {
      clipPath: "url(#SVGID_00000103979540576748656050000004377520222082546053_)",
      fill: "#808080"
    },
    width: 21.6,
    height: 12.4
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000183227724769408845050000013276204094043552429_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181051114237668436650000005626521346200818567_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000183227724769408845050000013276204094043552429_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181051114237668436650000005626521346200818567_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000083802900239191761440000006307572123024332703_",
    d: "M25,81.5c-2.6,0-4.7-2.1-4.7-4.7s2.1-4.7,4.7-4.7 c2.3,0,4.3,1.7,4.7,4l0.1,0.4h9c0,0.2-0.1,0.3-0.1,0.5h-8.9l-0.1,0.4C29.3,79.8,27.3,81.5,25,81.5 M25,72.6 c-2.3,0-4.2,1.9-4.2,4.2c0,2.3,1.9,4.2,4.2,4.2s4.2-1.9,4.2-4.2C29.2,74.4,27.3,72.6,25,72.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000094577105351033564390000003138381073961584002_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000083802900239191761440000006307572123024332703_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000094577105351033564390000003138381073961584002_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000158006832568560193470000016515510985070434968_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000008840766863445654630000007109011518375459712_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000158006832568560193470000016515510985070434968_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 19.3,
    y: 71.1,
    style: {
      clipPath: "url(#SVGID_00000008840766863445654630000007109011518375459712_)",
      fill: "#808080"
    },
    width: 20.5,
    height: 11.4
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000050624203405111034120000008673284914173623199_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000059281576910911643500000003988136198902866082_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000050624203405111034120000008673284914173623199_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000059281576910911643500000003988136198902866082_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000128478491234065919770000015686035680395074742_",
    d: "M146,77.5c0.4,2.5,2.5,4.5,5.2,4.5 c2.9,0,5.2-2.3,5.2-5.2c0-2.9-2.3-5.2-5.2-5.2c-2.6,0-4.8,1.9-5.2,4.5h-9.2c0.1,0.5,0.2,1,0.4,1.5h8.8V77.5z M151.2,73.1 c2,0,3.7,1.7,3.7,3.7s-1.7,3.7-3.7,3.7s-3.7-1.7-3.7-3.7C147.5,74.7,149.1,73.1,151.2,73.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000104685539989070614540000014750020752918827925_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000128478491234065919770000015686035680395074742_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000104685539989070614540000014750020752918827925_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000074422731311903853260000013217918878851617981_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000061431326336121710380000018148999456937757064_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000074422731311903853260000013217918878851617981_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 135.8,
    y: 70.6,
    style: {
      clipPath: "url(#SVGID_00000061431326336121710380000018148999456937757064_)",
      fill: "#808080"
    },
    width: 21.6,
    height: 12.4
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000107587436268758514170000015534733406327463855_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000019660680451424385300000017666674985012794507_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000107587436268758514170000015534733406327463855_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000019660680451424385300000017666674985012794507_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000013158353871723841120000002809355273872225925_",
    d: "M151.2,81.5c-2.3,0-4.3-1.7-4.7-4l-0.1-0.4h-8.9 c0-0.2-0.1-0.3-0.1-0.5h9l0.1-0.4c0.3-2.3,2.3-4,4.7-4c2.6,0,4.7,2.1,4.7,4.7C155.9,79.4,153.8,81.5,151.2,81.5 M151.2,72.6 c-2.3,0-4.2,1.9-4.2,4.2c0,2.3,1.9,4.2,4.2,4.2s4.2-1.9,4.2-4.2C155.4,74.4,153.5,72.6,151.2,72.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000159458304684641989360000018117132389822860172_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013158353871723841120000002809355273872225925_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000159458304684641989360000018117132389822860172_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000052073967226148829280000016684796937825406849_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000106112628072719706030000005109752996208889489_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000052073967226148829280000016684796937825406849_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 136.4,
    y: 71.1,
    style: {
      clipPath: "url(#SVGID_00000106112628072719706030000005109752996208889489_)",
      fill: "#808080"
    },
    width: 20.5,
    height: 11.4
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000052799751888339423860000012925903319475120538_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000011754027831451145390000005238795861728744371_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000052799751888339423860000012925903319475120538_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000011754027831451145390000005238795861728744371_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000179642399841506349530000014485781816711948725_",
    d: "M25,75.5c-0.7,0-1.3,0.6-1.3,1.3 c0,0.7,0.6,1.2,1.3,1.2s1.3-0.6,1.3-1.2C26.3,76.1,25.7,75.5,25,75.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000000937020954185863020000009092642049097140114_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000179642399841506349530000014485781816711948725_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000000937020954185863020000009092642049097140114_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000142137135851688989930000005693129214098026138_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000103233853103695232450000006165478447509125509_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000142137135851688989930000005693129214098026138_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 22.8,
    y: 74.5,
    style: {
      clipPath: "url(#SVGID_00000103233853103695232450000006165478447509125509_)",
      fill: "#808080"
    },
    width: 4.5,
    height: 4.5
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000087392126933923636030000015980030827435309983_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000092453013858334355330000007291317117088654728_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000087392126933923636030000015980030827435309983_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000092453013858334355330000007291317117088654728_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000067205481214204108650000011925692265329931198_",
    d: "M25,77.5c-0.4,0-0.7-0.3-0.7-0.7 c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7C25.8,77.2,25.4,77.5,25,77.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000047768614667081492500000003653038476434401420_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000067205481214204108650000011925692265329931198_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000047768614667081492500000003653038476434401420_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000000187162226849704280000007835526041894556553_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000056425926694176626110000015161916501841977496_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000000187162226849704280000007835526041894556553_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 23.3,
    y: 75,
    style: {
      clipPath: "url(#SVGID_00000056425926694176626110000015161916501841977496_)",
      fill: "#808080"
    },
    width: 3.5,
    height: 3.5
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000049913857159716197660000012282991108601617311_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000124842873377730333790000016261986415755786936_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000049913857159716197660000012282991108601617311_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000124842873377730333790000016261986415755786936_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000023976221182865902440000011867038502137449371_",
    d: "M24.1,104.7c-0.4-3-2.9-5.2-6-5.2c-3.3,0-6,2.7-6,6 s2.7,6,6,6c3.1,0,5.6-2.3,6-5.2h17.1c-0.2-0.5-0.4-1-0.5-1.5H24.1V104.7z M18.1,109.9c-2.5,0-4.5-2-4.5-4.5s2-4.5,4.5-4.5 s4.5,2,4.5,4.5S20.6,109.9,18.1,109.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000055703022755803659220000002878619145591187328_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000023976221182865902440000011867038502137449371_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000055703022755803659220000002878619145591187328_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000057855956801840934500000016270089658042426035_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000130647871322701753650000006354368309166685881_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000057855956801840934500000016270089658042426035_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 11.1,
    y: 98.4,
    style: {
      clipPath: "url(#SVGID_00000130647871322701753650000006354368309166685881_)",
      fill: "#808080"
    },
    width: 31,
    height: 14
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000023997569859925133860000000169030639574714559_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000179638918511449048520000011620282412398984092_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000023997569859925133860000000169030639574714559_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000179638918511449048520000011620282412398984092_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000049186707473637161180000012807402032766553499_",
    d: "M18.1,110.9c-3,0-5.5-2.5-5.5-5.5s2.5-5.5,5.5-5.5 c2.8,0,5.1,2.1,5.5,4.8l0.1,0.4h16.6c0.1,0.2,0.1,0.3,0.2,0.5H23.6l-0.1,0.4C23.2,108.9,20.9,110.9,18.1,110.9 M18.1,100.4 c-2.8,0-5,2.2-5,5s2.2,5,5,5s5-2.2,5-5C23.1,102.7,20.9,100.4,18.1,100.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000117644315084072295150000011421995019468509056_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000049186707473637161180000012807402032766553499_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000117644315084072295150000011421995019468509056_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000056399135177931139660000001401629194044046251_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000016060669227429999920000010595225076009887919_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000056399135177931139660000001401629194044046251_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 11.6,
    y: 99,
    style: {
      clipPath: "url(#SVGID_00000016060669227429999920000010595225076009887919_)",
      fill: "#808080"
    },
    width: 29.8,
    height: 13
  }))))))))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6,
    y: 34.1,
    className: "st0",
    width: 153,
    height: 108
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000145030522848724499970000014033488292324078486_",
    d: "M167.3,104.6h-31.7c-0.2,0.5-0.4,1-0.5,1.5h32.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000090296061427849721760000001090068036521763491_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000145030522848724499970000014033488292324078486_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000090296061427849721760000001090068036521763491_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000060734518340335867930000013485707373366516886_",
    x: 1.6,
    y: 24,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000091703390919990343900000006247332914616420744_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000060734518340335867930000013485707373366516886_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 134.1,
    y: 98.3,
    style: {
      clipPath: "url(#SVGID_00000091703390919990343900000006247332914616420744_)",
      fill: "#808080"
    },
    width: 33.2,
    height: 14
  })))))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6,
    y: 34.1,
    className: "st0",
    width: 153,
    height: 108
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000173156942283860044380000005667609071219139508_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000050641719310802570200000017902530819989644684_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000173156942283860044380000005667609071219139508_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000050641719310802570200000017902530819989644684_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000110467184909009396950000000257469076864686742_",
    d: "M158.1,106.9c0.8,0,1.5-0.7,1.5-1.5 s-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5C156.6,106.3,157.3,106.9,158.1,106.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000079445902071301227680000014545777017657889714_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000110467184909009396950000000257469076864686742_",
    style: {
      overflow: "visible"
    }
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000037676871215691958480000003403127042104909982_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000122700164722712642540000011572424613570174104_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000037676871215691958480000003403127042104909982_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000076574272485223089730000003801777181360709537_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000145757060260600472560000007265609330650460597_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000076574272485223089730000003801777181360709537_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000145757060260600472560000007265609330650460597_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs31 || (_defs31 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000140695796269009915000000009829532128716387774_",
    d: "M133.6,88.4c0-25-20.4-45.4-45.5-45.4 S42.6,63.4,42.6,88.4s20.4,45.4,45.5,45.4S133.6,113.4,133.6,88.4 M44.5,88.4c0-24,19.6-43.6,43.6-43.6 c24.1,0,43.6,19.5,43.6,43.6c0,24-19.6,43.6-43.6,43.6C64,132,44.5,112.4,44.5,88.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000036247846503230566760000015322385288051584139_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000140695796269009915000000009829532128716387774_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000036247846503230566760000015322385288051584139_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs32 || (_defs32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000087374496612148552330000012113716161227100567_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000113353015527201634500000001520229917053512068_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000087374496612148552330000012113716161227100567_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 41.6,
    y: 42,
    style: {
      clipPath: "url(#SVGID_00000113353015527201634500000001520229917053512068_)",
      fill: "#808080"
    },
    width: 92.9,
    height: 92.8
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs33 || (_defs33 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000110463416290209854310000012810532264415069592_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000047768444699146927140000010726913589248270722_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000110463416290209854310000012810532264415069592_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000047768444699146927140000010726913589248270722_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs34 || (_defs34 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000150086776585942346440000015101063367223211916_",
    d: "M88.1,133.3c-24.8,0-45-20.1-45-44.9 c0-24.7,20.2-44.9,45-44.9s45,20.1,45,44.9S112.9,133.3,88.1,133.3 M88.1,44.3C63.8,44.3,44,64.1,44,88.4s19.8,44.1,44.1,44.1 s44.1-19.8,44.1-44.1C132.3,64.1,112.5,44.3,88.1,44.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000136400554899205204660000002779537374962721683_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000150086776585942346440000015101063367223211916_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000136400554899205204660000002779537374962721683_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs35 || (_defs35 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000012464212446733724130000018357279614948733861_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000137105240036262245010000011314933264818948268_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000012464212446733724130000018357279614948733861_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 42.2,
    y: 42.5,
    style: {
      clipPath: "url(#SVGID_00000137105240036262245010000011314933264818948268_)",
      fill: "#808080"
    },
    width: 91.9,
    height: 91.8
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs36 || (_defs36 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000160157717235530193330000010001940762392689594_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000145775292545509302530000018349915539725533083_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000160157717235530193330000010001940762392689594_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000145775292545509302530000018349915539725533083_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs37 || (_defs37 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000152240309745764446380000015034872591381231766_",
    d: "M97.2,36.7l0.2-1.2c-6.3-1.1-12.9-1.1-19.1,0.1 l0.2,1.2C84.6,35.7,91,35.7,97.2,36.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000012453142311240703200000004232754580906297762_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152240309745764446380000015034872591381231766_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000012453142311240703200000004232754580906297762_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs38 || (_defs38 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000005229460321979226970000006919015816677934268_",
    x: 78.3,
    y: 34.7,
    width: 19.1,
    height: 3.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000068638774173950071890000005008112263465865376_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005229460321979226970000006919015816677934268_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 77.3,
    y: 33.7,
    style: {
      clipPath: "url(#SVGID_00000068638774173950071890000005008112263465865376_)",
      fill: "#808080"
    },
    width: 21.1,
    height: 4.1
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs39 || (_defs39 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000151506454791537759020000014819933788853835951_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000120516865671352443040000004237337889859469489_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000151506454791537759020000014819933788853835951_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000120516865671352443040000004237337889859469489_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs40 || (_defs40 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000044147470706990283750000007979819713318750895_",
    d: "M78.9,36c3-0.5,6.1-0.8,9.2-0.8 c2.9,0,5.8,0.2,8.7,0.7v0.2c-2.8-0.5-5.7-0.7-8.6-0.7c-3.1,0-6.2,0.3-9.2,0.8L78.9,36z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000021826331043943330160000006560484739465890473_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000044147470706990283750000007979819713318750895_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000021826331043943330160000006560484739465890473_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs41 || (_defs41 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000049179805972746914780000000185079912791372192_",
    x: 78.9,
    y: 34.7,
    width: 17.9,
    height: 3.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000119082852824288233190000008961637185763039394_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000049179805972746914780000000185079912791372192_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 77.9,
    y: 34.2,
    style: {
      clipPath: "url(#SVGID_00000119082852824288233190000008961637185763039394_)",
      fill: "#808080"
    },
    width: 19.9,
    height: 3
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs42 || (_defs42 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000132770676880379410530000000266865755831949472_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065052254191599464820000009155135434136228014_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000132770676880379410530000000266865755831949472_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000065052254191599464820000009155135434136228014_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs43 || (_defs43 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000059286560933707552730000009550234174519812999_",
    d: "M70.5,38.9l-0.4-1.2c-15.3,5.4-27.6,17.8-32.9,33.1 l1.2,0.4C43.6,56.3,55.6,44.2,70.5,38.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000039136098283063746470000012340297859064500407_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000059286560933707552730000009550234174519812999_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000039136098283063746470000012340297859064500407_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs44 || (_defs44 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000031171669016400156520000003928885036640483974_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000142889930755673029260000002984708154813997487_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000031171669016400156520000003928885036640483974_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 36.3,
    y: 36.8,
    style: {
      clipPath: "url(#SVGID_00000142889930755673029260000002984708154813997487_)",
      fill: "#808080"
    },
    width: 35.3,
    height: 35.5
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs45 || (_defs45 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000039099379914755120020000010851313410970262162_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000017493499264307878010000009536647868894391227_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000039099379914755120020000010851313410970262162_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000017493499264307878010000009536647868894391227_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs46 || (_defs46 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000013160689529673185910000006324609679075865483_",
    d: "M37.9,70.5c5.3-14.8,17.2-26.7,31.9-32.1l0.1,0.2 c-14.7,5.4-26.5,17.3-31.8,32L37.9,70.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000140696249255425934150000000320559895651056528_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013160689529673185910000006324609679075865483_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000140696249255425934150000000320559895651056528_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs47 || (_defs47 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000058575344603468021750000002761120676595906997_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000001621774803198926470000011008686038083748774_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000058575344603468021750000002761120676595906997_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 36.9,
    y: 37.4,
    style: {
      clipPath: "url(#SVGID_00000001621774803198926470000011008686038083748774_)",
      fill: "#808080"
    },
    width: 34,
    height: 34.1
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs48 || (_defs48 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000036930093407049896750000003036243465317973163_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000136385566907046877720000015753974762434614184_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000036930093407049896750000003036243465317973163_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000136385566907046877720000015753974762434614184_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs49 || (_defs49 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000046322873055590162630000016533000915193195658_",
    d: "M34.7,81.7c-0.3,2.2-0.4,4.5-0.4,6.7 c0,4.2,0.5,8.5,1.5,12.6l1.2-0.3c-1-4-1.4-8.1-1.4-12.3c0-2.2,0.1-4.4,0.4-6.6L34.7,81.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181063766796768732610000000797407937688288414_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000046322873055590162630000016533000915193195658_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181063766796768732610000000797407937688288414_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs50 || (_defs50 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000090283766382123647720000016569391438791711623_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000008843471476763544270000008918144168567940781_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000090283766382123647720000016569391438791711623_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 33.3,
    y: 80.7,
    style: {
      clipPath: "url(#SVGID_00000008843471476763544270000008918144168567940781_)",
      fill: "#808080"
    },
    width: 4.7,
    height: 21.3
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs51 || (_defs51 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000164489875274161721830000007249053361023655855_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000171717304029443436670000015503097843622031526_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000164489875274161721830000007249053361023655855_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000171717304029443436670000015503097843622031526_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs52 || (_defs52 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000136385320043762322220000006002504937735831959_",
    d: "M36.2,100.3c-0.9-3.9-1.3-7.9-1.3-11.9 c0-2.1,0.1-4.1,0.4-6.2h0.2c-0.2,2-0.4,4.1-0.4,6.1c0,4,0.4,8,1.3,11.9L36.2,100.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000038371573654529703250000003236808820709454268_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000136385320043762322220000006002504937735831959_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000038371573654529703250000003236808820709454268_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs53 || (_defs53 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000163065533845207941740000016824611391919657614_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168809779279165019370000009940125958742290343_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000163065533845207941740000016824611391919657614_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 33.8,
    y: 81.2,
    style: {
      clipPath: "url(#SVGID_00000168809779279165019370000009940125958742290343_)",
      fill: "#808080"
    },
    width: 3.5,
    height: 20.1
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs54 || (_defs54 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000101083108907800145990000012682795862695905448_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000135688202763793831870000014490064775462165408_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000101083108907800145990000012682795862695905448_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000135688202763793831870000014490064775462165408_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs55 || (_defs55 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000126298506308950881590000001080985572198927786_",
    d: "M68.9,138.6l0.4-1.1c-12.7-4.8-23.2-14.7-28.9-27 l-1.1,0.5C45.1,123.6,55.9,133.6,68.9,138.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000122684949192353844220000006085597148725448856_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000126298506308950881590000001080985572198927786_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122684949192353844220000006085597148725448856_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs56 || (_defs56 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000035526544144386623460000003871959063703679104_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000067203001677750564590000017535353824904839311_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000035526544144386623460000003871959063703679104_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 38.3,
    y: 109.5,
    style: {
      clipPath: "url(#SVGID_00000067203001677750564590000017535353824904839311_)",
      fill: "#808080"
    },
    width: 32,
    height: 30.1
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs57 || (_defs57 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000083811897706198054860000018413333476908287665_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000092430844987180065430000005207457799048597384_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000083811897706198054860000018413333476908287665_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000092430844987180065430000005207457799048597384_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs58 || (_defs58 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000109752676333727687670000004264388960277144229_",
    d: "M68.6,137.9C56.1,133,45.8,123.3,40,111.3l0.2-0.1 C45.9,123.2,56.3,132.9,68.6,137.9L68.6,137.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000054249185625509123100000001455849910893511595_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000109752676333727687670000004264388960277144229_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000054249185625509123100000001455849910893511595_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs59 || (_defs59 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000095296395733602057450000000634618057858214575_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000046302689340126309990000003879886640035305121_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000095296395733602057450000000634618057858214575_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 110.2,
    style: {
      clipPath: "url(#SVGID_00000046302689340126309990000003879886640035305121_)",
      fill: "#808080"
    },
    width: 30.7,
    height: 28.7
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs60 || (_defs60 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000036962949735961870640000016794565792529650850_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000160912206658271641830000003694723134201300379_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000036962949735961870640000016794565792529650850_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000160912206658271641830000003694723134201300379_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs61 || (_defs61 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000100346764789481341380000002187969445889003175_",
    d: "M105.8,37.8l-0.4,1.2c14.9,5.3,26.9,17.4,32.1,32.3 l1.2-0.4C133.4,55.6,121.1,43.2,105.8,37.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000022528333631181423900000013032983802150584747_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000100346764789481341380000002187969445889003175_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022528333631181423900000013032983802150584747_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs62 || (_defs62 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000147909062242274714660000014718601144277797553_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000120534036897226675010000012910744359433130913_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000147909062242274714660000014718601144277797553_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 104.4,
    y: 36.8,
    style: {
      clipPath: "url(#SVGID_00000120534036897226675010000012910744359433130913_)",
      fill: "#808080"
    },
    width: 35.3,
    height: 35.5
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs63 || (_defs63 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000002352549229670016250000011191485194920097153_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000063609249212691357130000015493794458081483444_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000002352549229670016250000011191485194920097153_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000063609249212691357130000015493794458081483444_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs64 || (_defs64 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000105406342410689164810000018189786220716295552_",
    d: "M137.9,70.6c-5.3-14.7-17.1-26.6-31.8-32l0.1-0.2 c14.7,5.4,26.6,17.3,31.9,32.1L137.9,70.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000155863281844174518860000016765220311833731229_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000105406342410689164810000018189786220716295552_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000155863281844174518860000016765220311833731229_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs65 || (_defs65 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000132049277917342479530000017753550204820076218_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000105385360613322966290000003097785277274817705_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000132049277917342479530000017753550204820076218_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 105.1,
    y: 37.5,
    style: {
      clipPath: "url(#SVGID_00000105385360613322966290000003097785277274817705_)",
      fill: "#808080"
    },
    width: 34,
    height: 34.1
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs66 || (_defs66 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000105394219254768415670000015451777518160288174_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000106145250322449067980000014850747700942632853_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000105394219254768415670000015451777518160288174_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000106145250322449067980000014850747700942632853_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs67 || (_defs67 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000034785226907311945310000003338417260180412550_",
    d: "M140.2,101c1-4.1,1.5-8.3,1.5-12.6 c0-2.3-0.1-4.5-0.4-6.7l-1.2,0.1c0.3,2.2,0.4,4.4,0.4,6.6c0,4.1-0.5,8.3-1.4,12.3L140.2,101z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013903808481068747120000018184124518896103580_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000034785226907311945310000003338417260180412550_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000013903808481068747120000018184124518896103580_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs68 || (_defs68 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000142854438846847263140000013390498920761340827_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000087398798902796722150000005349728817638893498_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000142854438846847263140000013390498920761340827_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 80.7,
    style: {
      clipPath: "url(#SVGID_00000087398798902796722150000005349728817638893498_)",
      fill: "#808080"
    },
    width: 4.7,
    height: 21.3
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs69 || (_defs69 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000000903404817946023980000016984042254158573976_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000153683841799014666390000008264521677412692373_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000000903404817946023980000016984042254158573976_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000153683841799014666390000008264521677412692373_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs70 || (_defs70 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000118398928216784945290000003316560133662488472_",
    d: "M139.6,100.3c0.9-3.9,1.3-7.9,1.3-11.9 c0-2.1-0.1-4.1-0.4-6.1h0.2c0.2,2,0.4,4.1,0.4,6.2c0,4-0.5,8-1.3,11.9L139.6,100.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000035494354413450801900000008272216086889754764_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000118398928216784945290000003316560133662488472_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000035494354413450801900000008272216086889754764_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs71 || (_defs71 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000157309734511570221390000017574771809015378358_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000178923613467982383520000017603456647475690880_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000157309734511570221390000017574771809015378358_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 138.6,
    y: 81.2,
    style: {
      clipPath: "url(#SVGID_00000178923613467982383520000017603456647475690880_)",
      fill: "#808080"
    },
    width: 3.5,
    height: 20.1
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs72 || (_defs72 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000183236604730090039540000003407682473421634495_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000139267299855620775340000003370425452781007289_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000183236604730090039540000003407682473421634495_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139267299855620775340000003370425452781007289_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs73 || (_defs73 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000149382013730775385510000005811684061311584406_",
    d: "M106.6,137.4l0.4,1.1c13-4.9,23.8-15,29.6-27.6 l-1.1-0.5C129.9,122.8,119.3,132.6,106.6,137.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000171717345659485747780000004727129877741229205_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000149382013730775385510000005811684061311584406_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000171717345659485747780000004727129877741229205_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs74 || (_defs74 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000142884636352316955040000013426499578108161719_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000019653957655657345790000017802448506481917840_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000142884636352316955040000013426499578108161719_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 105.6,
    y: 109.5,
    style: {
      clipPath: "url(#SVGID_00000019653957655657345790000017802448506481917840_)",
      fill: "#808080"
    },
    width: 32,
    height: 30.1
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs75 || (_defs75 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000058587411024422197510000016881747438381686153_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000093896688763785590690000006228713159667388551_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000058587411024422197510000016881747438381686153_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000093896688763785590690000006228713159667388551_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs76 || (_defs76 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000057863427242939073650000014743566314630852505_",
    d: "M107.3,137.7c12.4-4.9,22.8-14.5,28.5-26.6l0.2,0.1 c-5.8,12.1-16.2,21.8-28.6,26.7L107.3,137.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003098300678311972750000012439711994790404482_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000057863427242939073650000014743566314630852505_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000003098300678311972750000012439711994790404482_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs77 || (_defs77 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000072989233175083327700000017614258127943220358_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000131328596425438502230000011965695351676742544_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000072989233175083327700000017614258127943220358_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 106.3,
    y: 110.2,
    style: {
      clipPath: "url(#SVGID_00000131328596425438502230000011965695351676742544_)",
      fill: "#808080"
    },
    width: 30.7,
    height: 28.7
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs78 || (_defs78 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000101098478679434906380000014327246300029944488_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000127001613084203021170000003170405027295689895_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000101098478679434906380000014327246300029944488_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000127001613084203021170000003170405027295689895_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs79 || (_defs79 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000162340486736934130680000012462957444518264238_",
    d: "M96.2,141.5l-0.2-1.2c-5.3,0.8-10.9,0.8-16.3-0.1 l-0.2,1.2c2.8,0.5,5.7,0.7,8.6,0.7C90.8,142.1,93.5,141.9,96.2,141.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000083088749511105749670000012088128208206033845_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000162340486736934130680000012462957444518264238_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000083088749511105749670000012088128208206033845_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs80 || (_defs80 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000092448882571605060180000013560538720200668604_",
    x: 79.5,
    y: 138.6,
    width: 16.6,
    height: 3.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065074208938102901040000016281209674474852276_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000092448882571605060180000013560538720200668604_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 78.5,
    y: 139.2,
    style: {
      clipPath: "url(#SVGID_00000065074208938102901040000016281209674474852276_)",
      fill: "#808080"
    },
    width: 18.6,
    height: 3.9
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs81 || (_defs81 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000183226954816105041090000001245410806997457036_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000038372472040430669770000008903339155013891735_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000183226954816105041090000001245410806997457036_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000038372472040430669770000008903339155013891735_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs82 || (_defs82 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000119829117475242182840000008625956064862512058_",
    d: "M88.1,141.6c-2.7,0-5.4-0.2-8-0.6v-0.2 c2.6,0.4,5.3,0.6,8,0.6c2.5,0,5-0.2,7.4-0.5v0.2C93.1,141.4,90.6,141.6,88.1,141.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000000933385800850931000000009788704259167499401_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000119829117475242182840000008625956064862512058_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000000933385800850931000000009788704259167499401_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs83 || (_defs83 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000016792899796810231540000003780058161496784052_",
    x: 80.1,
    y: 138.6,
    width: 15.5,
    height: 3.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000029024671798846090140000000128915032006934415_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000016792899796810231540000003780058161496784052_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 79.1,
    y: 139.8,
    style: {
      clipPath: "url(#SVGID_00000029024671798846090140000000128915032006934415_)",
      fill: "#808080"
    },
    width: 17.5,
    height: 2.8
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpi1);
export default __webpack_public_path__ + "static/media/kpi-1.ef29c0b8583cd5317c88cea38922e0a5.svg";
export { ForwardRef as ReactComponent };